import { render } from "./releaseReply.vue?vue&type=template&id=21ed88f6&scoped=true"
import script from "./releaseReply.vue?vue&type=script&lang=js"
export * from "./releaseReply.vue?vue&type=script&lang=js"

import "./releaseReply.vue?vue&type=style&index=0&id=21ed88f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ed88f6"]])

export default __exports__